var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-podcast';
                    var viewUrl = 'sprite.svg#view-icon-podcast';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 38',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };